const { PageWrapper } = require('./src/components/system/PageWrapper')

exports.wrapPageElement = PageWrapper
